// src/prototype/components/hub/AsOfChip.tsx
// ============================================================
// "Scores as of {date}" marker — signals that rank/scores are live-computed
// from the latest scoring run. Used in the explorer, the hub header, and the
// scoring profile. Date/run come from the content adapter (SCORING_RUN provenance).
// ============================================================

import React from 'react';
import { SCORES_AS_OF, SCORING_RUN } from '../../data/adapters';

export interface AsOfChipProps {
  /** Render as bare inline text (no pill chrome). */
  inline?: boolean;
  className?: string;
}

export const AsOfChip: React.FC<AsOfChipProps> = ({ inline = false, className = '' }) => (
  <span
    title={`Scoring run ${SCORING_RUN}`}
    className={`inline-flex items-center gap-1.5 text-[10px] text-[#717182] ${
      inline ? '' : 'bg-[#F5F7FA] border border-[#e5e7eb] rounded-full px-2.5 py-1'
    } ${className}`}
  >
    <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
    Live-computed · scores as of {SCORES_AS_OF}
  </span>
);

export default AsOfChip;
